<div class="zn-step-content-sections">
  <div [class]="selectionSectionClass()">
    <div class="zn-step-content-section-header">
      <h5>{{ (localizationKeyPrefix + '.Selection.Title') | abpLocalization }}</h5>
      <p>{{ (localizationKeyPrefix + '.Selection.Description') | abpLocalization }}</p>
      <hr class="zn-separator">
    </div>
    <div class="zn-step-content-section-body">
      <div class="zn-step-content-section-layout">
        <div class="zn-step-content-section-filters">
          <div class="form-control-container">
            <label class="form-label" for="">
              {{ (localizationKeyPrefix + '.Selection.Label') | abpLocalization }}
              <span class="form-label-required">*</span>
            </label>
            <zn-multi-select
              #standCycleRotationSelect
              [options]="standCycleRotationOptions()"
              [optionsLoader]="loadStandCycleRotations"
              [deferSelection]="false"
              (selectedChange)="onStandCycleRotationChange($event)"
            >
            </zn-multi-select>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div [class]="tableSectionClass()">
    <div class="zn-step-content-section-header">
      <h5>{{ (localizationKeyPrefix + '.Table.Title') | abpLocalization }}</h5>
      <p>{{ (localizationKeyPrefix + '.Table.Description') | abpLocalization }}</p>
      <hr class="zn-separator">
    </div>
    <div class="zn-step-content-section-body">
      <div class="zn-table" [class.zn-table--empty]="rows().length === 0">
        <div class="zn-table-scroll">
          <table class="zn-table-element">
            <thead>
              <tr>
                <th></th>
                <th>{{ columnHeaderKeys.stand | abpLocalization }}</th>
                <th>{{ columnHeaderKeys.cycle | abpLocalization }}</th>
                <th>{{ columnHeaderKeys.rotation | abpLocalization }}</th>
                <th>{{ columnHeaderKeys.area | abpLocalization }}</th>
                <th>{{ columnHeaderKeys.standType | abpLocalization }}</th>
                <th>{{ columnHeaderKeys.nearbyPopulation | abpLocalization }}</th>
                <th>{{ columnHeaderKeys.maintenancePeriod | abpLocalization }}</th>
                <th>{{ columnHeaderKeys.maintenanceReason | abpLocalization }}</th>
                <th>{{ columnHeaderKeys.adjustmentType | abpLocalization }}</th>
                <th>{{ columnHeaderKeys.plantationDate | abpLocalization }}</th>
                <th>{{ columnHeaderKeys.ownPlantation | abpLocalization }}</th>
                <th>{{ columnHeaderKeys.spacing | abpLocalization }}</th>
                <th>{{ columnHeaderKeys.plantationType | abpLocalization }}</th>
                <th>{{ columnHeaderKeys.geneticMaterial | abpLocalization }}</th>
                <th>{{ columnHeaderKeys.species | abpLocalization }}</th>
              </tr>
            </thead>
            <tbody>
              @if (rows().length === 0) {
                <tr>
                  <td class="zn-table-empty" colspan="16">
                    {{ 'LanguageService::EmptySearchResultTitle' | abpLocalization }}
                  </td>
                </tr>
              }
              @for (row of rows(); track row.key) {
                <tr>
                  <td class="zn-action-container">
                    <button
                      class="btn btn-tertiary btn-sm btn-delete"
                      type="button"
                      (click)="removeRow(row.key)"
                      [attr.aria-label]="(localizationKeyPrefix + '.Table.Remove') | abpLocalization"
                    >
                      <i class="bi bi-trash3"></i>
                    </button>
                  </td>
                  <td>{{ row.stand }}</td>
                  <td>{{ row.cycle }}</td>
                  <td>{{ row.rotation }}</td>
                  <td>{{ row.area }}</td>
                  <td>{{ row.standType }}</td>
                  <td>{{ row.nearbyPopulation }}</td>
                  <td>{{ row.maintenancePeriod }}</td>
                  <td>{{ row.maintenanceReason }}</td>
                  <td>{{ row.adjustmentType }}</td>
                  <td>{{ row.plantationDate }}</td>
                  <td>{{ row.ownPlantation }}</td>
                  <td>{{ row.spacing }}</td>
                  <td>{{ row.plantationType }}</td>
                  <td>{{ row.geneticMaterial }}</td>
                  <td>{{ row.species }}</td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
